import { useRecoilValue } from "recoil"
import styled from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { T4_en, T4_ko } from "../../../style/constant"


const History = () => {
  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)
  return(
    <Container>
      <Title currentLang={currentLang}>{Text.history.title}</Title>
      <Wrapper>
        {Text.history.achievement.map(item => (
          <Content>
            <LeftYear>{item.year}</LeftYear>
            <PerformanceArea>
              <RightYear>{item.year}</RightYear>
              <Performance>
                {item.desc.map(item => 
                  <li>{item}</li>
                )}
              </Performance>
            </PerformanceArea>
          </Content>
        ))}
      </Wrapper>
    </Container>
  )
}


export default History

interface Props {
  currentLang:boolean;
}

const Container = styled.section`
  color:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1a1a41;
`

const Title = styled.p<Props>`
  margin:100px 0;
 
  ${props => props.currentLang ? 
  `
    ${T4_ko}
  `
  :
  `
    ${T4_en}
  `
}
`

const Wrapper = styled.div`
  margin:50px auto;

`

const Content = styled.div`
  display: flex;
  opacity: 0.4;
  :hover{
    opacity: 1;
  }
`

const PerformanceArea = styled.div`
  margin-left:30px;
  position:relative;
  padding-bottom:20px;

  :before{
    position:absolute;
    content:"";
    top:10px;
    left:-16px;
    width:2px;
    height:100%;
    background-color: #fff;
  }

`

const LeftYear = styled.p`
  display:inline-block;
  font-size:90px;
  width:250px;
`

const RightYear = styled.p`
  font-size:24px;
  position:relative;
  :before{
    position:absolute;
    z-index: 10;
    content:"";
    top:50%;
    transform:translateY(-50%);
    left:-20px;
    width:10px;
    height:10px;
    border-radius: 100%; 
    background-color  : #fff;
  }
`

const Performance = styled.ol`
  padding:20px 0 74px; 
  li{
    font-size:17px;
    font-weight: 400;
    margin-bottom:14px;
  }
`